import type { ScheduleDetail } from "@/api/schedule/models";
import { Tag } from "@/components/common/Tag";
import { Tooltip } from "@/components/common/Tooltip";
import {
  SCHEDULE_CANCELLATION_REASON_TRANSLATIONS,
  SCHEDULE_PAUSE_REASON_TRANSLATIONS,
  SCHEDULE_STATUS_LABEL_BY_STATUS,
  SCHEDULE_STATUS_TAG_COLOR_BY_STATUS,
} from "@/constants/schedule";

type ScheduleStatusTagProps = {
  schedule: Pick<
    ScheduleDetail,
    "status" | "pauseReason" | "pausedByUser" | "cancellationReason" | "cancellationReasonDetails" | "canceledByUser"
  >;
};

export const ScheduleStatusTag = ({
  schedule: { status, pauseReason, pausedByUser, cancellationReason, cancellationReasonDetails, canceledByUser },
}: ScheduleStatusTagProps) => {
  const tag = (
    <Tag color={SCHEDULE_STATUS_TAG_COLOR_BY_STATUS[status]} className="align-middle">
      {SCHEDULE_STATUS_LABEL_BY_STATUS[status]}
    </Tag>
  );

  if (status === "CANCELED") {
    const reason =
      (cancellationReason && SCHEDULE_CANCELLATION_REASON_TRANSLATIONS[cancellationReason]) || "Não informado";
    const author = canceledByUser?.name?.trim() || "Não informado";

    return (
      <Tooltip trigger={tag} position="top-right">
        <div className="flex flex-col gap-2">
          <div>
            <p className="font-medium mb-0.5">Motivo</p>
            <p className="break-words font-normal">{reason}.</p>
          </div>
          {cancellationReasonDetails && (
            <div>
              <p className="font-medium mb-0.5">Observações</p>
              <p className="break-words font-normal">{cancellationReasonDetails}</p>
            </div>
          )}
          <div>
            <p className="font-medium mb-0.5">Autor do cancelamento</p>
            <p className="font-normal">{author}</p>
          </div>
        </div>
      </Tooltip>
    );
  }

  if (status !== "PAUSED") {
    return tag;
  }

  const reason = (pauseReason && SCHEDULE_PAUSE_REASON_TRANSLATIONS[pauseReason]) || "Não informado";
  const author = pausedByUser?.name?.trim() || "Não informado";

  return (
    <Tooltip trigger={tag} position="top-right">
      <div className="flex flex-col gap-2">
        <div>
          <p className="font-medium mb-0.5">Motivo da pausa</p>
          <p className="break-words font-normal">{reason}.</p>
        </div>
        <div>
          <p className="font-medium mb-0.5">Pausado por</p>
          <p className="font-normal">{author}</p>
        </div>
      </div>
    </Tooltip>
  );
};
